module.exports = __webpack_public_path__ + "img/panda.be5030ca.webp";